import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import { CustomInput, Button } from 'reactstrap'
import DatePicker from 'react-datepicker'
import { FONTS, COLORS } from '../../../constants'

export default class SearchBarHeadcountFilter extends React.Component {
  render() {
    const handleDate = get(this.props, 'handleDate')
    const handleLOB = get(this.props, 'handleLOB')
    const handleClickApply = get(this.props, 'handleClickApply')
    const startDate = get(this.props, 'startDate')
    const endDate = get(this.props, 'endDate')
    const lobList = get(this.props, 'lobList', [])
    const selectedLOB = get(this.props, 'selectedLOB')
    /* eslint no-underscore-dangle: 0 */
    return (
      <Wrapper>
        <Text>Report according to period of</Text>
        <LOBDatePicker
          onChange={ (e) => handleDate('startDate', e) }
          autoComplete='off'
          placeholderText='DD/MM/YYYY'
          selected={ startDate }
          dateFormat="DD/MM/YYYY"
          showYearDropdown
          showMonthDropdown
        />
        <TextTo>to</TextTo>
        <LOBDatePicker
          onChange={ (e) => handleDate('endDate', e) }
          autoComplete='off'
          placeholderText='DD/MM/YYYY'
          selected={ endDate }
          dateFormat="DD/MM/YYYY"
          showYearDropdown
          showMonthDropdown
        />
        <TextTo>LOB</TextTo>
        <CustomInputField
          type="select"
          value={ selectedLOB }
          onChange={ (e) => handleLOB(e) }
        >
          { lobList.map(lob =>
            <option key={ lob.lob_id } value={ lob.lob_id }>{ lob.lob_name }</option>)
          }
        </CustomInputField>
        <ExportButton
          bg={ COLORS.UPLOAD_COLOR }
          onClick={ () => handleClickApply() }
        >
          Apply
        </ExportButton>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  background-color: #ffffff;  
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
`
const ExportButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-right: 10px;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  border-radius: 4px;
  position: relative;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const Text = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-left: 10px;
  margin-right: 10px;
`
const TextTo = styled(Text)`
  margin-right: 1%;
`
const LOBDatePicker = styled(DatePicker)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  width : 100px ;
  height : 30px ;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
  border: 1px solid #cccccc;
  @media (max-width: 575.98px) {
    width: 100%;
  }
`
const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  width : 120px;
  height : 80%;
  margin-left: 10px;
  margin-right: 10px;
`



// WEBPACK FOOTER //
// ./src/components/report/search-bar/headcount-filter.js